// ============================================
// Image Utilities - Centralized Image URL Generation
//DRY: Avoid repeating image URL logic across components
// ============================================

import { IMAGE_SIZES } from '../config/constants';

type ImageSize = 'small' | 'medium' | 'large' | 'original';
type ImageType = 'poster' | 'backdrop' | 'profile';

/**
 * Get TMDB image URL with specified size
 */
export function getImageUrl(
    path: string | null,
    type: ImageType,
    size: ImageSize = 'original'
): string | null {
    if (!path) return null;

    const sizeMap = IMAGE_SIZES[type];
    if (!sizeMap) return null;

    return `${sizeMap[size]}${path}`;
}

/**
 * Get poster URL
 */
export function getPosterUrl(path: string | null, size: ImageSize = 'large'): string | null {
    return getImageUrl(path, 'poster', size);
}

/**
 * Get backdrop URL
 */
export function getBackdropUrl(path: string | null, size: ImageSize = 'original'): string | null {
    return getImageUrl(path, 'backdrop', size);
}

/**
 * Get profile URL
 */
export function getProfileUrl(path: string | null, size: ImageSize = 'medium'): string | null {
    return getImageUrl(path, 'profile', size);
}

/**
 * Get placeholder image for missing posters/backdrops
 */
export function getPlaceholderImage(type: 'poster' | 'backdrop' | 'profile'): string {
    const placeholders = {
        poster: '/placeholder-poster.jpg',
        backdrop: '/placeholder-backdrop.jpg',
        profile: '/placeholder-actor.jpg',
    };
    return placeholders[type];
}

/**
 * Get image with fallback
 */
export function getImageWithFallback(
    path: string | null,
    type: ImageType,
    size: ImageSize = 'original'
): string {
    return getImageUrl(path, type, size) || getPlaceholderImage(type);
}
